import React from 'react';
import PropTypes from 'prop-types';
import { CallbackComponent } from 'redux-oidc';

import userManager from '../../state/userManager';

const LoginCallbackPage = ({ history }) => {
  const onLoginSuccess = () => {
    history.push('/app/dashboard');
  };

  const onLoginError = (err) => {
    console.log('Falha ao Logar'); // eslint-disable-line
    console.log(err); // eslint-disable-line
  };

  return (
    <CallbackComponent
      userManager={userManager}
      successCallback={onLoginSuccess}
      errorCallback={onLoginError}
    >
      <div>Redirecting...</div>
    </CallbackComponent>
  );
};

LoginCallbackPage.propTypes = {
  history: PropTypes.object.isRequired,
};

export default LoginCallbackPage;
